module.exports = __webpack_public_path__ + "static/media/print-sgombero.c3eaffc3.jpg";